var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWeeklyRental = function SvgWeeklyRental(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "#F0EDED",
    rx: 32
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "url(#weekly-rental_svg__a)",
    rx: 32
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "url(#weekly-rental_svg__b)",
    rx: 32
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "url(#weekly-rental_svg__c)",
    fillOpacity: 0.63,
    rx: 32
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "#fff",
    fillOpacity: 0.33,
    rx: 32
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "#895FFC",
    rx: 32
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "url(#weekly-rental_svg__d)",
    rx: 32
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "#fff",
    fillOpacity: 0.65,
    rx: 32
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 2.571,
    height: 6.857,
    x: 20.428,
    y: 13.107,
    fill: "#000",
    rx: 1.286
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 2.571,
    height: 6.857,
    x: 30.714,
    y: 13.107,
    fill: "#000",
    rx: 1.286
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 2.571,
    height: 6.857,
    x: 41,
    y: 13.107,
    fill: "#000",
    rx: 1.286
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M26.296 41.636c.802 0 1.296.462 1.296 1.27 0 .807-.494 1.265-1.296 1.265h-.704v-2.535zM31.626 43.374h-1.05l.525-1.46z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M19.143 18.679a2.571 2.571 0 0 0 5.142 0v-2.572h5.144v2.572a2.571 2.571 0 1 0 5.143 0v-2.572h5.142v2.572a2.572 2.572 0 0 0 5.143 0v-2.572h2.572A2.57 2.57 0 0 1 50 18.68V47.82a2.573 2.573 0 0 1-2.571 2.573H16.572A2.57 2.57 0 0 1 14 47.82V18.68a2.57 2.57 0 0 1 2.572-2.572h2.57zm20.219 22.025c-.947 0-1.698.453-1.698 1.21 0 .786.494 1.161 1.405 1.331.745.139 1.028.273 1.028.607 0 .272-.283.462-.663.463-.535 0-.885-.267-.937-.668h-.96c.04.894.796 1.454 1.83 1.455.936 0 1.692-.49 1.692-1.291 0-.628-.33-1.106-1.296-1.306-.818-.17-1.142-.278-1.142-.592 0-.252.242-.427.679-.427.447 0 .72.221.776.586h.967c-.046-.797-.746-1.368-1.681-1.368m-14.707.104v4.191h1.627c1.388 0 2.247-.854 2.247-2.094s-.86-2.097-2.247-2.097zm5.999 0-1.625 4.191h.966l.293-.812h1.626l.293.812h1.044l-1.625-4.191zm2.359 0 1.568 2.875v1.316h.936v-1.316l1.57-2.875h-.994l-1.003 1.98-1.008-1.98zm-4.481-13.695h5.508a3.3 3.3 0 0 0-.324.54v.016c-.014 0-.015.012-.016.015l-.061.124-.016.015v.015c-.092.154-.23.432-.293.54-1.311 2.823-2.746 5.462-4.057 8.3h2.36l4.675-9.95v-1.512h-7.776z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "weekly-rental_svg__a",
    x1: -61.464,
    x2: 212.244,
    y1: 32,
    y2: 31.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#895FFC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#9E7AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E90F9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "weekly-rental_svg__b",
    x1: 6.624,
    x2: 61.947,
    y1: 64,
    y2: 64.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E90F9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429,
    stopColor: "#3682FA",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E90F9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "weekly-rental_svg__c",
    x1: -15.203,
    x2: 106.834,
    y1: 31.886,
    y2: 31.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "weekly-rental_svg__d",
    x1: 0,
    x2: 64,
    y1: 32,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E90F9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E90F9"
  })))));
};
export default SvgWeeklyRental;